import React, { useState, useEffect, useMemo } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import { AccountsandFinanceurl } from "../../../../config";
import { accountSubcategoryFields } from "../../../../data/DynamicTable/AccountsDynamicForms";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../../data/Axios/DynamicService";
import { allAccountCategories } from "../../../../data/Axios/queries";

const base_url = AccountsandFinanceurl.uri;

const AccountSubCategoryForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);
  const [categoryData, setCategoryData] = useState([]);
  const [loading, setLoading] = useState(true);
 useEffect(() => {
    async function fetchAllData() {
      try {
        const data = await graphqlQuery(allAccountCategories, base_url);
        console.log("data:", data);
        setCategoryData(data);
        
        console.log("data:", data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchAllData();
  }, []);
   const steps = useMemo(() => [
      {
        stepLabel: "Basic Information",
        stepDescription: "Account SubCategories",
        icon: "assignment_ind",
        fields: ["accountName","accountCategoryId"],
      },
    ], []);
  
  const initialValues = {
    id: props.data?.id ?? "",
    accountName: props.data?.accountCategoryName || props.data?.accountName || "",
    accountCategoryName: props.data?.accountCategoryName || props.data?.accountName || "",
    accountCategoryId: props.data?.accountCategoryId ?? "",
    accountCategory: props.data?.accountCategory ?? "",
    companyId: props.data?.companyId ?? companyId,
  };
 
  const CategoryOptions = categoryData
    ? categoryData.map((data) => ({
        parent_key: data.id,
        value: data.id,
        label: data.categoryName,
      }))
    : [];
  const fields = [
     {
    name: "accountName",
    label: "Account Sub-Category Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
    {
      name: "accountCategoryId",
      label: "Account Category ",
      type: "select",
      options: CategoryOptions,
      gridColumn: "span 2",
      required: true,
    },
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const {
        accountCategory,
        accountCategoryId,
        accountName,
        accountCategoryName,
      } = values;

      const selectedCategory = CategoryOptions.find(
        (c) => c.value == accountCategoryId
      )?.label;

      const mutationData = props.isEditing
        ? {
            id: props.data.id,
            accountCategoryId: parseInt(accountCategoryId),
            accountCategoryName: accountName || accountCategoryName,
            isActive: true,
          }
        : {
            accountCategoryId: parseInt(accountCategoryId),
            accountCategoryName: accountName || accountCategoryName,
            isActive: true,
          };

      const response = await generateAndExecuteMutation(
        props.isEditing
          ? "updateAccountSubCategory"
          : "createAccountSubCategory",
        mutationData,
        props.isEditing ? "updatedAccountSubCategory" : "newAccountSubCategory",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Account sub-category ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={
        props.isEditing
          ? "Edit Account Sub-Category"
          : "Create Account Sub-Category"
      }
      subtitle={
        props.isEditing
          ? "Edit an Existing Account Sub-Category"
          : "Create a New Account Sub-Category"
      }
    />
  );
};

export default AccountSubCategoryForm;
